export default __webpack_public_path__ + "cf8dded.png";